module.exports = __webpack_public_path__ + "img/qiaoxinliang.8235672d.png";